import React from 'react'
import Translation from '../global/Translation'

import { connect } from 'react-redux'
import { getSelectedChannel, getSelectedSalesForceId, getSalesforceRelationsV3 } from '../../store/segmentation/reducers'
import { selectSalesForceId } from '../../store/segmentation/actions'
import Select from 'react-select'

const mapStateToProps = (state, props) => {
    return {
        selected: getSelectedSalesForceId(state),
        options: getSalesforceRelationsV3(state, props.inProfile),
        currentChannel: getSelectedChannel(state)
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onSelect: (value, name, subchannelProgram, businessSegment, subchannelId, locationPk) => {
            dispatch(selectSalesForceId(value, name, subchannelProgram, businessSegment, subchannelId, locationPk))
        }
    }
}
class SalesForceIdV3 extends React.Component {
    render() {
        const { selected, onSelect, options, intl, currentChannel } = this.props
        if (options === undefined) {
            return ''
        }
        return (
            <div>
                <div className="segmentation-segment-title">
                    {typeof currentChannel === 'string' && currentChannel.startsWith('leads') ?
                        (<Translation id="potential_customer" defaultMessage="Potential customer" />)
                        :
                        (<Translation id="account" defaultMessage="Account" />)
                    }
                </div>
                <Select
                    placeholder={intl.formatMessage({ id: 'choose_option' })}
                    options={Object.entries(options).map(option => {
                        const projectOptions = Object.values(option[1].projectOptions)[0]
                        return {
                            label: option[1].name === '' ? 'RESIDENTIAL' : option[1].name,
                            value: option[0],
                            businessSegment: option[1].businessSegment,
                            subchannelProgram: projectOptions.subchannelProgram,
                            subchannelId: projectOptions.subchannelId,
                            locationPk: projectOptions.locationPk
                        }
                    })}
                    value={selected}
                    onChange={option => {
                        option && onSelect(option.value, option.label, option.subchannelProgram, option.businessSegment, option.subchannelId, option.locationPk)
                    }}
                    clearable={false}
                />
            </div>
        )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SalesForceIdV3)
